import { To } from 'react-router-dom';
import { AppURLSearchParams } from './searchParamKeys';
import { useLocationWithState } from './useLocationWithState';
import { useNavigateWithHistory } from './useNavigateWithHistory';

export const getValidItemId = (str?: string) => str?.match(/1-\d+/);

export const getValidItemPath = (str?: string) => str?.match(/\/1-\d+/);

export const itemIdRegex = /(1-\d+)/;

export const appUrlSearchParamsToString = (params: AppURLSearchParams) => {
  const urlSearchParams = new URLSearchParams();

  urlSearchParams.set('resolution', params.resolution);

  if (params.e2eTests) {
    urlSearchParams.set('e2e_tests', params.e2eTests.toString());
  }

  if (params.uri) {
    urlSearchParams.set('uri', params.uri);
  }

  return urlSearchParams.toString();
};

export const addSearchParam = (
  url: string,
  key: keyof AppURLSearchParams,
  value: string
) => {
  return url.concat(/\?/.test(url) ? '&' : '?', key, '=', value);
};

export function clearSearchParamAndNavigate(
  pathname: To,
  searchParamKey: keyof AppURLSearchParams,
  navigate: ReturnType<typeof useNavigateWithHistory>,
  location: ReturnType<typeof useLocationWithState>
) {
  const keyValueStrings = location.search.replace('?', '').split('&');

  const searchParamsFiltered = keyValueStrings
    .filter(keyValueStr => {
      const [key] = keyValueStr.split('=');

      return key !== searchParamKey;
    })
    .join('&');

  navigate(pathname, {
    state: {
      from: {
        search: searchParamsFiltered,
      },
    },
  });
}
